import Button from '@tencent/dui/lib/components/Button';
import Modal from '@tencent/dui/lib/components/Modal';
import React, { Fragment } from 'react';
import i18n from '@i18next/i18n';
import styles from './index.less';

export interface IHowToDetailConfig {
    disableRefresh?: boolean;
    disableCreateCopyDoc?: boolean;
    disableExportSnapshot?: boolean;
    disableOpenHistoryList?: boolean;
    disableConnectUs?: boolean;
}

export interface IConnectUsModalShowParams {
    config?: IHowToDetailConfig;
    refresh?: () => void;
    createCopyDoc?: () => void;
    exportSnapshot?: () => void;
    openHistoryList?: () => void;
    connectUs?: () => void;
    exportDBToJson?: () => void;
}

export default class ConnectUsModal {
    public static instance: ConnectUsModal;
    public static getInstance(): ConnectUsModal {
        if (!ConnectUsModal.instance) {
            ConnectUsModal.instance = new ConnectUsModal();
        }
        return ConnectUsModal.instance;
    }

    private shouldExportDB = false;
    public show = (params: IConnectUsModalShowParams) => {
        const { close } = Modal.confirm({
            mask: false,
            title: i18n.t('如何处理'),
            content: this.getRenderContent(params),
            footer: () => {},
            onClose: () => {
                close();
            },
        });
        const fn = () => {
            this.shouldExportDB = true;
            close();
            setTimeout(() => this.show(params), 200);
            document.getElementById('deal-export-head')?.removeEventListener('dblclick', fn);
        };
        document.getElementById('deal-export-head')?.addEventListener('dblclick', fn);
    };

    private getRenderContent = (params: IConnectUsModalShowParams) => {
        const { config } = params;
        const renderRefresh = () => ((params.refresh && !config?.disableRefresh)
            ? <div className={styles.item}>
                <div className={styles.explain}>{i18n.t('如果您是第一次遇到错误，请直接刷新，大部分情况可以恢复')}</div>
                <Button className={styles.btn} type='primary' size='small' onClick={params.refresh}>{i18n.t('刷新')}</Button>
            </div> : null);
        const renderCreateCopyDoc = () => ((params.createCopyDoc && !config?.disableCreateCopyDoc) ? (
            <div className={styles.item}>
                <div className={styles.explain}>{i18n.t('将当前文档以副本的形式备份，并保留未提交的数据到副本中')}</div>
                <Button className={styles.btn} type='primary' size='small' onClick={params.createCopyDoc}>{i18n.t('备份到在线文档')}</Button>
            </div>
        ) : null);
        const renderExportDoc = () => ((params.exportSnapshot && !config?.disableExportSnapshot) ? (
            <div className={styles.item}>
                <div className={styles.explain}>{i18n.t('将当前文档及尚未同步云端的数据导出为一个本地文档（.pptx）')}</div>
                <Button className={styles.btn} type='primary' size='small' onClick={params.exportSnapshot}>{i18n.t('备份到本地')}</Button>
            </div>
        ) : null);
        const renderHistoryItem = () => ((params.openHistoryList && !config?.disableOpenHistoryList) ? (
            <div className={styles.item}>
                <div className={styles.explain}>{i18n.t('通过修订记录，恢复到正常可用版本')}</div>
                <Button className={styles.btn} type='primary' size='small' onClick={params.openHistoryList}>{i18n.t('打开修订记录')}</Button>
            </div>
        ) : null);
        const renderConnectUs = () => (params.connectUs ? (
            <Fragment>
                <div className={styles.head}>{i18n.t('联系我们')}</div>
                <div className={styles.item}>
                    <div className={styles.answer}>{i18n.t('如果以上方法无法解决问题，或者有其他宝贵意见，请联系我们')}</div>
                    <Button className={styles.btn} type='primary' size='small' onClick={params.connectUs}>{i18n.t('联系我们')}</Button>
                </div>
            </Fragment>
        ) : null);
        const renderExportDB = () => ((params.exportDBToJson && this.shouldExportDB) ? (<Button className={styles.btn} type='primary' size='small' onClick={params.exportDBToJson}>{i18n.t('导出DB')}</Button>) : null);
        return (
            <div className={ styles['how-to-deal'] }>
                <div className={styles.head} id="deal-export-head">{i18n.t('为何会出现此类情况？')}</div>
                <div className={styles.answer}>{i18n.t('网络不通畅、服务波动、文档数据异常等原因造成')}。{i18n.t('尝试通过')}<span className={styles.highlight}>{i18n.t('任选以下其一')}</span>{i18n.t('的方式恢复')}:</div>
                { renderRefresh() }
                { renderCreateCopyDoc() }
                { renderExportDoc() }
                { renderHistoryItem() }
                { renderConnectUs() }
                { renderExportDB() }
            </div>
        );
    };
}
